import { InteractionType } from "@azure/msal-browser";
import { useMsalAuthentication } from "@azure/msal-react";

export function RequireLogin({ children }) {
  useMsalAuthentication(InteractionType.Redirect);
  return <>{children}</>;
}
